<template>
  <fragment>
    <b-button
      id="tooltip-target-login-name-hint"
      variant="link"
      size="sm"
      v-b-tooltip.hover
      class="tooltip-login-name"
    >
      {{ $t("loginNameHint") }}
    </b-button>
    <b-tooltip
      target="tooltip-target-login-name-hint"
      triggers="hover"
      container="tooltip-target-login-name-hint"
      boundary="viewport"
    >
      <ol class="login-name-policy-list">
        <li
          class="login-name-policy-list__item"
          v-for="desc of descriptions"
          :key="desc"
        >
          {{ desc }}
        </li>
      </ol>
    </b-tooltip>
  </fragment>
</template>

<script>
import { UserApi } from "nx-libs";

export default {
  data() {
    return {
      descriptions: []
    };
  },
  async created() {
    this.descriptions = (await UserApi.getAccountHints()).data;
  }
};
</script>

<style lang="scss" scoped>
.login-name-policy-list {
  padding-left: 1rem;
  &__item {
    text-align: left;
  }
}
.tooltip-login-name {
  padding: 0rem;
}
</style>

<i18n src="@/locales/login.locale.json" />
